import { SnowplowService } from 'wanderu-service-analytics';

function updateTravelerButtonClicked({
    itineraryId,
    travelers,
    increase,
}: {
    itineraryId: string;
    travelers: number;
    increase: boolean;
}) {
    SnowplowService.fireStructuredEventWithBatchId({
        action: 'click',
        category: 'react_tripsummary',
        label: increase
            ? 'add_traveler'
            : 'subtract_traveler',
        property: {
            itinerary_id: itineraryId,
            travelers,
        },
    });
}

function updateWheelchairSeatButtonClicked({
    itineraryId,
    wheelchairs,
    increase,
}: {
    itineraryId: string;
    wheelchairs: number;
    increase: boolean;
}) {
    SnowplowService.fireStructuredEventWithBatchId({
        action: 'click',
        category: 'react_tripsummary',
        label: increase
            ? 'add_wheelchair'
            : 'subtract_wheelchair',
        property: {
            itinerary_id: itineraryId,
            wheelchairs,
        },
    });
}

export default {
    updateTravelerButtonClicked,
    updateWheelchairSeatButtonClicked,
};
